import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error'
import type { RepoStandardResponse } from '@webapp/infrastructure/interfaces/repositories/RepoStandardResponse'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type IRequestRepository } from '@webapp/modules/spending-cards/business-logic/interfaces/IRequestRepository'
import { type CreateRequestPayload } from '@webapp/modules/spending-cards/data-access/types/CreateRequestPayload'
import { type CreateRequestResponse } from '@webapp/modules/spending-cards/data-access/types/CreateRequestResponse'
import { type CreateRequestInputData } from '../../types/CreateRequestInputData'

const PAY_REQUEST_API_URL_V4 = '/api/v4/pay/requests'

interface Dependency {
  httpClient: IHttpClient
}

export class RequestRepository implements IRequestRepository {
  constructor(private readonly deps: Dependency) {}

  async createRequest(
    data: CreateRequestInputData
  ): Promise<{ id: number; uuid: uuid } | undefined> {
    const payload: CreateRequestPayload = {
      account: data.accountId,
      amount: data.amount.toString(),
      title: data.purpose,
      reason: data.additionalDetails,
      department: data.secondaryCategoryId,
      next_approver: data.nextApproverId,
      card: data.cardId,
      cardholder: data.cardholderId,
      fund: data.fundId,
      attachments: data.attachments,
      allow_budget_overage: data.confirmedBudgetOverage,
    }

    try {
      const res = await this.deps.httpClient.post<
        RepoStandardResponse<CreateRequestResponse>,
        CreateRequestPayload
      >(`${PAY_REQUEST_API_URL_V4}/`, payload)

      const responseData = res.data.data

      return {
        id: responseData.id,
        uuid: responseData.uuid,
      }
    } catch (err) {
      throwRepoErrorFromApiV3Error(err)
    }
  }
}
